import gql from 'graphql-tag';

const GET_DSP_INVENTORY_SOURCES = gql`
  query getDspInventorySources($forceRefresh: Boolean, $marketId: String, $inventorySourceType: String, $offset: Int, $limit: Int) {
    dspInventorySources(forceRefresh: $forceRefresh, marketId: $marketId, inventorySourceType: $inventorySourceType, offset: $offset, limit: $limit) {
      queryTotal
      data {
        id
        name
        inventorySourceType
        status
      }
    }
  }
`;

export default GET_DSP_INVENTORY_SOURCES;
